import { __assign } from "tslib";
// DS: i4.10
import React from 'react';
import IconWrap from '../IconWrap';
var Check = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 8 8", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1.237 6.187L0 4.95l1.237-1.238L2.475 4.95l3.712-3.713 1.238 1.238-4.95 4.95-1.238-1.238z", fillRule: "evenodd" })))); };
Check.displayName = 'Check';
export default Check;
//# sourceMappingURL=Check.js.map